import { getListOfApprovals, supTripApprovalCount } from '../../../api/supportAdmin';
import errorHandle from '../../../utils/errorHandle';

//List dropdown
export const fetchApprovals = (setApprovalsData, setLoading, limit, offset, type) => {
    setLoading(true);
    try {
        getListOfApprovals(limit, offset, type).then((res) => {
            setApprovalsData(res.data);
            setLoading(false);
        });
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};

export const approvalsCount = (setTotalCount, type, setLoading) => {
    setLoading(true);
    try {
        supTripApprovalCount(type).then((res) => {
            setLoading(false);
            setTotalCount(res.data.count);
        });
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};
